import { z } from 'zod'

export const ADMINORGUSERSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgUsersGetResponseSchema = z.unknown()
export type AdminOrgUsersGetResponse = z.infer<typeof adminOrgUsersGetResponseSchema>
